//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveFileUrl } from "@/libs/fileUrl";
export default {
  props: {
    propImg: [String]
  },
  data: function data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/common/upload",
      imageUrl: ""
    };
  },
  methods: {
    resolveFileUrl: resolveFileUrl,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      console.log(res, file, '55');
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit("successUpLoad", res);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  },
  created: function created() {
    if (!this.imageUrl) {
      this.imageUrl = this.$route.query.imageUrl;
    }
  }
};